import Markdown from 'markdown-it';
import hljs from 'highlight.js';
import katex from 'markdown-it-katex';
import markdownItImgAttrs from '@/libs/markdown-it-img-attrs';
import markdownItVideo from '@/libs/markdown-it-video';
import { escapeMaskedAsterisks } from '@/libs/markdownContent';
import { applyExternalLinkOpenRule } from '@/libs/markdownLinkOpen';

const md = new Markdown({
  linkify: false,
  typographer: false,
  breaks: true,
  html: true,
  highlight(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<pre class="hljs"><code>${
          hljs.highlight(str, { language: lang }).value
        }</code></pre>`;
      } catch (__) {}
    }

    return `<pre class="hljs"><code>${str}</code></pre>`;
  }
});

md.use(katex, {
  throwOnError: false,
  errorColor: '#cc0000',
  strict: false
});

md.use(markdownItImgAttrs);
md.use(markdownItVideo);

applyExternalLinkOpenRule(md);

const markdownRender = md.render.bind(md);
// `escapeMaskedAsterisks` guards streamed chat output, where masked values such
// as `138****8888` arrive in fragments and adjacent runs can be paired into
// emphasis. It also escapes `**bold**` that sits flush against CJK characters,
// so static documents opt out explicitly with `{ maskAsterisks: false }`.
md.render = (text, env) =>
  markdownRender(
    env?.maskAsterisks === false ? text : escapeMaskedAsterisks(text),
    env
  );

md.renderWithEnv = (text, env) => {
  return md.render(text, env);
};

md.renderer.rules.fence = (tokens, idx) => {
  const token = tokens[idx];
  const code = token.content.trim();
  const langName = token.info ? token.info.trim().split(/\s+/)[0] : '';

  const highlightedCode =
    langName && hljs.getLanguage(langName)
      ? hljs.highlight(code, { language: langName }).value
      : hljs.highlightAuto(code).value;
  const escapedLangName = md.utils.escapeHtml(langName);

  const copyBtn = `<div class="copy-code-wrap" >
    <span>${escapedLangName}</span>
    <copy-code-button data-code="${md.utils.escapeHtml(
      code
    )}"></copy-code-button>
  </div>`;

  return `<div class="code-block-wrap ">${copyBtn}<pre class="code-block max-h-[400px] overflow-y-auto custom-scrollbar"><code class="language-${escapedLangName}">${highlightedCode}</code></pre></div>`;
};

export default md;
